import {
  DEFAULT_NOVA_POSHTA_SETTINGS,
  getNovaPoshtaFreeDeliveryThreshold,
} from "../api/siteSettingsApi";
import { isKyivCourierDelivery } from "../api/checkoutDeliverySettingsApi";

export const getOrderFreeDeliveryThreshold = (order = {}) => {
  const snapshot = Number(order.freeDeliveryThresholdSnapshot);
  if (Number.isFinite(snapshot) && snapshot > 0) return snapshot;
  const novaPoshtaThreshold = getNovaPoshtaFreeDeliveryThreshold(
    order.deliveryMethod,
    DEFAULT_NOVA_POSHTA_SETTINGS
  );
  if (novaPoshtaThreshold) return novaPoshtaThreshold;
  return isKyivCourierDelivery(order.deliveryMethod)
    ? DEFAULT_NOVA_POSHTA_SETTINGS.courierFreeDeliveryThreshold
    : null;
};

export const isOrderFreeDelivery = (order = {}) => {
  if (order.manualFreeDelivery?.enabled || order.automaticFreeDelivery === true) {
    return true;
  }
  const threshold = getOrderFreeDeliveryThreshold(order);
  return Boolean(threshold && Number(order.totalAmount || 0) >= threshold);
};
